const message = "firebase-inappmessaging-custom-display is not support on web";

const noSupport = () => console.log(message);

export default {
  setMessagesDisplaySuppressed: noSupport,
  setAutomaticDataCollectionEnabled: noSupport,
  triggerEvent: noSupport,
};
